import { createStore } from 'vuex';
import user from './modules/user';
import permission from './modules/permission';
import tagsView from './modules/tagsView';
import RoleMangae from './modules/themes/RoleMangae';
export default createStore({
    state: {
        registerVerifyCodeToken: ''
    },
    mutations: {
        setRegisterVerifyCodeToken(state, token) {
            state.registerVerifyCodeToken = token;
        }
    },
    actions: {},
    modules: {
        user,
        permission,
        tagsView,
        RoleMangae
    }
});
